<template>
	<div class="success" id="index">
		<div class="topinfo">您已成功领取《高考一轮复习方向作业》，赠书将送到学校由老师分发给考生。</div>
		<div class="box">
			<!-- <img v-if="button_status == 1" class="coupon" @click="QuesCoupon(1)" src="@assets/images/coupon_get.jpg" alt=""> -->
			<!-- <img v-if="button_status == 2" class="coupon" @click="QuesCoupon(2)" src="@assets/images/coupon_use.jpg" alt=""> -->
			<img class="product product-img" src="@assets/images/product.jpg" alt="">
			<img class="product" src="@assets/images/submit_success_b.jpg" alt="">
			<div class="gocar" @click="tapBuy()">
				<img src="@assets/images/gocar.png">
			</div>
			<Product-window v-on:changeFun="changeFun" :attr="attr" :type="0" :productid="productid"></Product-window>
		</div>
		<!-- 弹框 -->
		<div id="mask" v-show="maskshow">
			<!-- 200元优惠券 -->
			<div v-show="isshow200" class="mask_box mask_box1">
				<img src="@assets/images/mask_img1.png" alt="">
				<div @click="sign(jump_url)" class="boxbutton sign">去签约</div>
				<div @click="buyBook()" class="boxbutton buybook">仍购书</div>
			</div>
			<!-- 1000元优惠券 -->
			<div  v-show="isshow1000" class="mask_box mask_box2">
				<img src="@assets/images/mask_img3.png" alt="">
				<div @click="sign(jump_url)" class="boxbutton sign">去签约</div>
				<div @click="buyBook()" class="boxbutton buybook">仍购书</div>
			</div>
			<img @click="closeMask()" class="maskclose" src="@assets/images/maskclose.png">
		</div>
	</div>
</template>

<script>
import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getProductCode,
  storeListApi
} from "@api/store";
import {
  getCoupon,
  getCollectAdd,
  getCollectDel,
  getUserInfo,
  getQuesCoupon,
  QuesCoupon
} from "@api/user";
import ProductWindow from "@components/ProductWindow";
import { getSeckillDetail } from "@api/activity";

export default{
	name:"SubmitSuccess",
	data:function(){
		return{
			maskshow:false,
			jump_status:1,
			button_status:1,
			isshow200:false,
			isshow1000:false,
			jump_url:"",
			//立即购买
			productid:0,
			shareInfoStatus: false,
			weixinStatus: false,
			mapShow: false,
			mapKey: "",
			posterData: {
			  image: "",
			  title: "",
			  price: "",
			  code: ""
			},
			posterImageStatus: false,
			animated: false,
			coupon: {
			  coupon: false,
			  list: []
			},
			attr: {
			  cartAttr: false,
			  productAttr: [],
			  productSelect: {},
					RuleData:{}
			},
			RuleDatares:[],
			isOpen: false, //是否打开属性组件
			productValue: [],
			id: 0,
			storeInfo: {},
			couponList: [],
			attrTxt: "请选择",
			attrValue: "",
			cart_num: 1, //购买数量
			replyCount: "",
			replyChance: "",
			reply: [],
			priceName: 0,
			CartCount: 0,
			posters: false,
			swiperRecommend: {
			  pagination: {
			    el: ".swiper-pagination",
			    clickable: true
			  },
			  autoplay: false,
			  loop: false,
			  speed: 1000,
			  observer: true,
			  observeParents: true
			},
			goodList: [],
			system_store: {},
			storeSelfMention: true,
			storeItems: {},
			activity: [],
			navList: [],
			lock: false,
			navActive: 0,
			opacity: 0
		}
	},
	components: {
		ProductWindow
	},
	mounted: function() {
		var winHeight = window.screen.availHeight;
		var thisHeight = document.getElementById("index");
		var maskHight = document.getElementById("mask");
		thisHeight.style.height = winHeight + "px";
		maskHight.style.height = winHeight + "px";
		this.getQuesCoupon();
	},
	methods:{
		//一进页面访问
		getQuesCoupon:function(){
			let that = this;
			let data = that.$route.params;
			getQuesCoupon(data).then(function(res){
				that.jump_status = res.data.jump_status;
				that.button_status = res.data.button_status;
			}).catch(function(err){
				if(err.msg == "领取的优惠劵已过期!"){
					window.location.href = "https://tmall.fc62.com/end_activity.html";
				}else{
					that.$dialog.error(err.msg);
				}
			});
		},
		//领取200元优惠券
		QuesCoupon: function(type) {
		  let that = this;
		  let id = that.$route.params.id;
		  let urlSource = that.$cookies.get('urlSource');
		  QuesCoupon(id,type,urlSource).then(function(res) {
			  that.jump_status = res.data.jump_status;
			  that.button_status = res.data.button_status;
			  that.jump_url = res.data.jump_url;
			  switch(res.data.jump_status){
				  case 1:
				  that.tapBuy();
				  break;
				  case 2:
				  that.maskshow = true;
				  that.isshow200 = true;
				  break;
				  case 3:
				  that.$dialog.error(res.data.msg);
				  break;
				  case 4:
				  that.maskshow = true;
				  that.isshow1000 = true;
				  break;
			  }
		    }).catch(function(res) {
		      that.$dialog.toast({ mes: res.msg });
		    });
		},
		//去签约
		sign:function(jump_url){
			window.location.href = jump_url;
		},
		//仍购书
		buyBook:function(){
			this.maskshow = false;
			window.scroll(0, 100);
		},
		//关闭弹框
		closeMask: function(){
			this.maskshow = false;
		},
		//购物车；
		//打开属性插件；
		selecAttrTap: function() {
		  if (this.storeInfo.activity_status === 1) {
		    this.attr.cartAttr = true;
		    this.isOpen = true;
		     	document.getElementById("index").classList.add("noscoll");
		  }
		},
		openAlone: function() {
		  this.$router.push({ path: "/detail/" + this.storeInfo.product_id });
		},
		mountedStart: function(id) {
		  var that = this;
		  // let id = that.$route.params.id;
		  getSeckillDetail(id).then(res => {
		    // that.datatime = parseInt(res.data.storeInfo.stop_time);
		    that.$set(that, "storeInfo", res.data.storeInfo);
			that.$set(that.attr, "RuleData", res.data.RuleData);
		    that.$set(that, "imgUrls", res.data.storeInfo.images);
		    that.$set(that, "replyCount", res.data.replyCount);
		    that.$set(that, "replyChance", res.data.replyChance);
		    if (res.data.reply)
		      that.$set(that, "reply", Array.from(res.data.reply) || []);
		    that.posterData.image = that.storeInfo.image_base;
		    that.attr.productAttr = res.data.productAttr;
		    that.productValue = res.data.productValue;
		    let navList = ["商品", "评价", "详情"];
		    that.navList = navList;
		    that.updateTitle();
		    if (that.storeInfo.title.length > 30) {
		      that.posterData.title = that.storeInfo.title.substring(0, 30) + "...";
		    } else {
		      that.posterData.title = that.storeInfo.title;
		    }
		    that.posterData.price = that.storeInfo.price;
		    that.posterData.code = that.storeInfo.code_base;
		    // that.setProductSelect();
		 //    that.getImageBase64();
		 //    that.setShare();
		    if (that.attr.productAttr != 0) that.DefaultSelect();
			if(that.attr.RuleData.spec_type == 1){
				that.getsubject();
			}
		  }).catch(err => {
			  alert(11)
			  that.$dialog.error(err.msg);
			  // that.$router.go(-1);
		  });
		},
		setShare: function() {
		  this.$wechat.isWeixin() &&
		    openShareAll({
		      desc: this.storeInfo.info,
		      title: this.storeInfo.title,
		      link: location.href,
		      imgUrl: this.storeInfo.image
		    });
		},
		getImageBase64: function() {
		  let that = this;
		  imageBase64(this.posterData.image, that.posterData.code).then(res => {
		    that.posterData.image = res.data.image;
		    that.posterData.code = res.data.code;
		  });
		},
		updateTitle() {
		  document.title = this.storeInfo.title || this.$route.meta.title;
		},
		setPosterImageStatus: function() {
		  var sTop = document.body || document.documentElement;
		  sTop.scrollTop = 0;
		  this.posterImageStatus = !this.posterImageStatus;
		},
		//将父级向子集多次传送的函数合二为一；
		changeFun: function(opt) {
		  var that = this;
		  if(opt.action == "ChangeSubject"){
			  that.RuleDatares = opt.value;
		  }
		  if(opt.action == "define"){
		  	that.tapBuy();
		  }
		  if (typeof opt !== "object") opt = {};
		  let action = opt.action || "";
		  let value = opt.value === undefined ? "" : opt.value;
		  this[action] && this[action](value);
		},
		changeattr: function(res) {
		  var that = this;
		  that.attr.cartAttr = res;
		},
		//选择属性；
		ChangeAttr: function(res) {
		  let productSelect = this.productValue[res];
		  if (productSelect) {
		    this.$set(this.attr.productSelect, "image", productSelect.image);
		    this.$set(this.attr.productSelect, "price", productSelect.price);
		    this.$set(this.attr.productSelect, "quota", productSelect.quota);
		    this.$set(this.attr.productSelect, "unique", productSelect.unique);
		    this.$set(this.attr.productSelect, "cart_num", 1);
		    this.$set(
		      this.attr.productSelect,
		      "stock",
		      productSelect.product_stock
		    );
		    this.$set(
		      this.attr.productSelect,
		      "quota_show",
		      productSelect.quota_show
		    );
		    this.$set(this, "attrValue", res);
		    this.$set(this, "attrTxt", "已选择");
		  } else {
		    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
		    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
		    this.$set(this.attr.productSelect, "quota", 0);
		    this.$set(this.attr.productSelect, "unique", "");
		    this.$set(this.attr.productSelect, "cart_num", 0);
		    this.$set(this.attr.productSelect, "quota_show", 0);
		    this.$set(this.attr.productSelect, "stock", 0);
		    this.$set(this, "attrValue", "");
		    this.$set(this, "attrTxt", "请选择");
		  }
		},
		ChangeCartNum: function(res) {
		  //changeValue:是否 加|减
		  //获取当前变动属性
		  let productSelect = this.productValue[this.attrValue];
		  //如果没有属性,赋值给商品默认库存
		  if (productSelect === undefined && !this.attr.productAttr.length)
		    productSelect = this.attr.productSelect;
		  if (productSelect === undefined) return;
		  let quota = productSelect.quota || 0;
		  let num = this.attr.productSelect;
		  if (res) {
		    num.cart_num++;
		    if (num.cart_num > quota) {
		      this.$set(this.attr.productSelect, "cart_num", quota);
		      this.$set(this, "cart_num", quota);
		    }
		  } else {
		    num.cart_num--;
		    if (num.cart_num < 1) {
		      this.$set(this.attr.productSelect, "cart_num", 1);
		      this.$set(this, "cart_num", 1);
		    }
		  }
		},
		//默认选中属性；
		DefaultSelect: function() {
		  let productAttr = this.attr.productAttr,
		    value = [];
		  for (var key in this.productValue) {
		    if (this.productValue[key].quota > 0) {
		      value = this.attr.productAttr.length ? key.split(",") : [];
		      break;
		    }
		  }
		  for (let i = 0; i < productAttr.length; i++) {
		    this.$set(productAttr[i], "index", value[i]);
		  }
		  //sort();排序函数:数字-英文-汉字；
		  // let productSelect = this.productValue[value.sort().join(",")];
		  let productSelect = this.productValue[value.join(",")];
		  if (productSelect && productAttr.length) {
		    this.$set(this.attr.productSelect, "store_name", this.storeInfo.title);
		    this.$set(this.attr.productSelect, "image", productSelect.image);
		    this.$set(this.attr.productSelect, "price", productSelect.price);
		    this.$set(this.attr.productSelect, "quota", productSelect.quota);
		    this.$set(this.attr.productSelect, "unique", productSelect.unique);
		    this.$set(this.attr.productSelect, "cart_num", 1);
		    this.$set(
		      this.attr.productSelect,
		      "stock",
		      productSelect.product_stock
		    );
		    this.$set(
		      this.attr.productSelect,
		      "quota_show",
		      productSelect.quota_show
		    );
		    // this.$set(this, "attrValue", value.sort().join(","));
			this.$set(this, "attrValue", value.join(","));
		    this.$set(this, "attrTxt", "已选择");
		  } else if (!productSelect && productAttr.length) {
		    this.$set(this.attr.productSelect, "store_name", this.storeInfo.title);
		    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
		    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
		    this.$set(this.attr.productSelect, "quota", 0);
		    this.$set(this.attr.productSelect, "unique", "");
		    this.$set(this.attr.productSelect, "cart_num", 0);
		    this.$set(this.attr.productSelect, "quota_show", 0);
		    this.$set(this.attr.productSelect, "stock", 0);
		    this.$set(this, "attrValue", "");
		    this.$set(this, "attrTxt", "请选择");
		  } else if (!productSelect && !productAttr.length) {
		    this.$set(this.attr.productSelect, "store_name", this.storeInfo.title);
		    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
		    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
		    this.$set(this.attr.productSelect, "quota", 0);
		    this.$set(this.attr.productSelect, "quota_show", 0);
		    this.$set(this.attr.productSelect, "stock", 0);
		    this.$set(
		      this.attr.productSelect,
		      "unique",
		      this.storeInfo.unique || ""
		    );
		    this.$set(this.attr.productSelect, "cart_num", 1);
		    this.$set(this, "attrValue", "");
		    this.$set(this, "attrTxt", "请选择");
		  }
		  this.isCheckedValue(1);
		},
		//获取被选中科目
		
		getsubject: function(){
			let that = this;
			let RuleData = that.attr.RuleData.attr_values[that.attr.productAttr[0].index];
			let value = [];
			for(let i=0;i<RuleData.length;i++){
				if(RuleData[i].check){
					value.push(RuleData[i].attr);
				}
			}
			that.RuleDatares = value;
		},
		//判断属性是否可选
		isCheckedValue: function(type){
		  let that = this;
		  let productAttr = this.attr.productAttr;
		  let return_d = true
		  if(type != 1){
		     return_d = false;
		  }
		  for (let i = 0; i < productAttr.length; i++) {
		    for (let j = 0; j < productAttr[i].attr_value.length; j++) {
		       //console.log(productAttr[i].index+'4444444444');
		      if (productAttr[i].index === productAttr[i].attr_value[j].attr) {
		        //console.log(type+'---------333333');
		        if(productAttr[i].attr_value[j].disabled_info){
		           for (var key in productAttr[i].attr_value[j].disabled_info_data) {
		              for(var ke in productAttr[i].attr_value[j].disabled_info_data[key]){
		               // console.log(productAttr[i].attr_value[j].disabled_info_data[key][ke]);
		                //console.log(ke);
		                this.attr.productAttr[key]['attr_value'][ke]['disabled'] = return_d;
		              }
		              //console.log(productAttr[i].attr_value[j].disabled_info_data[key]);
		            }
		        }
		      }
		    }
		  }
		  // if(!that.attr.productValue[value.join(",")]){
		  //   that.isChecked = false;
		  // }
		  //return that.isChecked;
		},
		setProductSelect: function() {
		  var that = this;
		  var attr = that.attr;
		  attr.productSelect.image = that.storeInfo.image;
		  attr.productSelect.store_name = that.storeInfo.title;
		  attr.productSelect.price = that.storeInfo.price;
		  attr.productSelect.quota = 0;
		  attr.productSelect.stock = 0;
		  attr.cartAttr = false;
		  that.$set(that, "attr", attr);
		},
		tapBuy: function() {
		  var that = this;
		  that.mountedStart(15);
		  that.$set(that, "productid", 77);
		  if (that.attr.cartAttr == false) {
		    that.attr.cartAttr = !this.attr.attrcartAttr;
		  } else {
		    var data = {};
		    data.productId = 77;
		    data.cartNum = that.attr.productSelect.cart_num;
		    data.uniqueId = that.attr.productSelect.unique;
		    data.secKillId = that.storeInfo.id;
			data.spec_type = that.attr.RuleData.spec_type,
			data.spec_values = that.RuleDatares.join(','),
		    data.new = 1;
			if(that.attr.RuleData.spec_type == 1){
				var checkedarr = that.attr.RuleData.attr_values[that.attr.productAttr[0].index];
				var check_num = [];
				for(var i = 0; i < checkedarr.length; i++){
				  if(checkedarr[i].check){
					  check_num.push(checkedarr[i].check);
				  }
				}
				//console.log(check_num.length);
				var sepc_num = that.attr.RuleData.attr_value[that.attr.productAttr[0].index].sepc_num;
				if(check_num.length < sepc_num || data.spec_values == ""){
					that.$layer.msg("选择科目不能小于"+sepc_num+"科");
				}else{
					postCartAdd(data).then(function(res) {
						  //console.log(res);
						  that.isOpen = false;
						  that.attr.cartAttr = false;
						  document.getElementById("index").classList.remove("noscoll");
						  that.$router.push({ path: "/order/submit/" + res.data.cartId });
					 }).catch(res => {
						  that.isOpen = false;
						  document.getElementById("index").classList.remove("noscoll");
						  return that.$dialog.toast({ mes: res.msg });
					 });
				}
			}else{
					  postCartAdd(data).then(function(res) {
						  //console.log(res);
						  that.isOpen = false;
						  that.attr.cartAttr = false;
						  document.getElementById("index").classList.remove("noscoll");
						  that.$router.push({ path: "/order/submit/" + res.data.cartId });
					   }).catch(res => {
						  that.isOpen = false;
						  document.getElementById("index").classList.remove("noscoll");
						  return that.$dialog.toast({ mes: res.msg });
					   });
			}
		    
		  }
		},
		
	}
}
</script>

<style scoped>
.noscoll{
	height: 100%;
	overflow: hidden;
}
.success{
	padding: 0.3rem;
	background: url(../../assets/images/success_bg.jpg) no-repeat;
	background-size: 100% 100%;
	background-color: #f2211c;
}
.topinfo{
	background-color: #f5ef75;
	border-radius: 5px;
	font-size: 0.28rem;
	padding: 0.4rem 0.3rem;
	line-height: 0.43rem;
	color: #000;
}
.box{
	background-color: #fff;
	margin-top: 0.28rem;
	border-radius: 5px;
	position: relative;
	overflow: hidden;
	/* padding: 0 0.4rem; */
}
.coupon{
	width: 87%;
	display: block;
	margin: 0.6rem auto;
}
img.product{
	width: 100%;
	display: block;
	/* margin-bottom: 0.6rem; */
}
img.product-img{
	width: 90%;
	margin: 0 auto;
}
.gocar{
	position: absolute;
	bottom: 40%;
	right: 6%;
	border-radius: 50%;
}
.gocar img{
	width: 0.89rem;
	height: 0.89rem;
}
#mask{
	background: rgba(0,0,0,0.7);
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 998;
}
.mask_box{
	z-index: 999;
	width: 77%;
	margin: 45% auto;
	margin-bottom: 0;
	position: relative;
}
.mask_box img{
	width: 100%;
}
.hide{
	display: none;
}
.boxbutton{
	position: absolute;
	bottom: 0.45rem;
	border-radius: 12px;
	width: 1.7rem;
	height: 0.5rem;
	line-height: 0.5rem;
	text-align: center;
	color: #fff;
}
.sign{
	background-color: #0aabff;
	left: 13%;
}
.buybook{
	background-color: #fe8300;
	left: 55%;
}
.maskclose{
	display: block;
	width: 0.68rem;
	height: 0.68rem;
	margin: 10% auto;
}
</style>
